import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=f13b54fe"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"
import style0 from "./CompanyView.vue?vue&type=style&index=0&id=f13b54fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports